import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ../~/react-toastify/~/react-transition-group/esm/TransitionGroupContext.js
// module id = 187
// module chunks = 0